<template>
  <div class="mt-16">
    <div class="sm:flex z-20 relative">
      <CategoryFilter />
      <TagFilter />
    </div>
    <div class="flex flex-col-reverse sm:flex-row mt-8 justify-between" >
      <div class="flex w-full xs:w-auto relative">
        <svg class="w-6 h-6 mb-2 mr-2 sm:inline-block absolute top-2.5 left-2.5" style="fill: #7f7f7f">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-search"></use>
        </svg>
        <jet-input id="search" type="text" class="block w-full pl-9 pt-2.5" style="max-width: 600px; max-height: 44px; margin-bottom: 7px;" placeholder="Produktname oder Artikelnummer" v-model="filter.search" @change="onSearchInputChange" />
        <svg v-if="filter.search !== ''" @click="clearSearchInput" class="w-4 h-4 mt-3.5 relative cursor-pointer search-clear-icon right-8" style="fill: #7f7f7f">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
        </svg>
      </div>
      <div v-if="selectedTags" class="flex justify-center sm:justify-end flex-wrap sm:max-w-sm w-full mb-4 sm:mb-0">
        <Tag
          v-for="tag in selectedTags"
          class="m-1"
          :key="tag.id"
          :label="tag.name"
          closeable
          @select="() => removeTag(tag)" />
      </div>
    </div>
  </div>
</template>

<script>
import filterStore from '@/Store/filter'

import CategoryFilter from './CategoryFilter'
import TagFilter from './TagFilter'
import Tag from './Tag'
import JetInput from '@/Jetstream/Input'

export default {
  name: 'Filter',
  components: { CategoryFilter, TagFilter, Tag, JetInput },

  data: () => ({
    filter: filterStore.state
  }),

  computed: {
    tags() {
      return this.$page.props.tags
    },

    selectedTags() {
      return this.tags.filter(({ id }) => this.filter.tags.indexOf(id) > -1)
    }
  },

  methods: {
    removeTag(tag) {
      filterStore.removeTagAction(tag)
    },

    onSearchInputChange(search) {
      filterStore.setSearchTextAction(search.target.value)
    },

    clearSearchInput() {
      filterStore.clearSearchTextAction()
    }
  }
}
</script>

<style scoped>
  .search-clear-icon:hover {
    fill: black !important;
  }
</style>
